<template>
  <div class="hero section-type-b bground-config-clean presentation">
    <div class="personal-container">
      <div class="row section-type-b pt-5">
        <div class="col-12 presentation-inner-padding-top2">
          <div>
            <h1 class="text-center text-light mb-24">Grupo Felix</h1>
            <h2 class="text-center text-light mb-64">Línea de autos nuevos</h2>
          </div>
          <img
            src="@/assets/images/marcas/CADILLAC LOGO-01.png"
            class="d-block mx-auto mb-64"
            style="max-width: 125px"
            alt=""
          />
          <div
            class="row section-type-c car-search justify-content-center mb-64"
          >
            <div class="col-12 car-results">
              <div class="row no-gutters">
                <!--Aqui van los coches-->
                <CocheCard
                  v-bind:key="coche.idVehiculo"
                  v-for="coche in coches"
                  :id="coche.idVehiculo"
                  :urlBackgroundImage="coche.portada"
                  :carModel="coche.nombre"
                  :releaseYear="coche.nombre"
                  :stock="1"
                  :initialPayment="coche.contado"
                  :monthlyCost="coche.mensualidad"
                  :colors="coche.colores"
                ></CocheCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CocheCard from "@/components/CocheCard";

export default {
  name: "AutosNuevosCadillac",
  components: {
    CocheCard,
  },
  data() {
    return {
      coches: [],
      vehiculosRemoteApi: [],
      vehiculosApiLocal: [],
      STATUS: "1",
    };
  },
  async mounted() {
    window.addEventListener("sucursal-changed", async (event) => {
      this.mapData();
    });
    await this.getDataLocalAPI();
    this.mapData();

    const vehiculosLocalStorage = JSON.parse(
      localStorage.getItem("vehiculos-globaldms-api")
    );

    if (vehiculosLocalStorage) {
      this.vehiculosRemoteApi = vehiculosLocalStorage;
      this.mapData();
    }

    // await this.getCarsGlobalDmsApi()
    // this.mapData()
  },
  methods: {
    async getDataLocalAPI() {
      // &idSucursal=${localStorage.getItem('suc')}
      const responseLocalAPI = await this.$http.get(
        `${this.API_URL}/web/vehicles/marca/?page=1&limit=50&marca=2`
      );
      this.vehiculosApiLocal = responseLocalAPI.data.data.elementos;
    },
    async getCarsGlobalDmsApi() {
      const vehiculos = await this.$http.get("/globaldms/vehiculos.asp");
      this.vehiculosRemoteApi = vehiculos.data;
      localStorage.setItem(
        "vehiculos-globaldms-api",
        JSON.stringify(this.vehiculosRemoteApi)
      );
    },
    mapData() {
      if (parseInt(localStorage.getItem("suc"))) {
        const vehiculosWhereSucursal = this.vehiculosApiLocal.filter(
          (car) =>
            car.marca_id === 2 &&
            car.sucursal_id === parseInt(localStorage.getItem("suc")) //&&
        );
        this.coches = vehiculosWhereSucursal;
      } else {
        const vehiculosWhereSucursal = this.vehiculosApiLocal.filter(
          (car) => car.marca_id === 2
        );
        this.coches = vehiculosWhereSucursal;
      }
    },
  },
};
</script>

<style scoped>
</style>
